// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicePlansItems-servicePlanCard-japf8 {
    background-color: var(--secondary-gray-bg);
    border-radius: 16px;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    position: relative;
    border: 6px solid var(--primary-white-bg);
    -webkit-transition: -webkit-box-shadow .1s linear;
    transition: -webkit-box-shadow .1s linear;
    transition: box-shadow .1s linear;
    transition: box-shadow .1s linear, -webkit-box-shadow .1s linear;
}

.ServicePlansItems-servicePlanActiveCard-XgtSD {
    -webkit-box-shadow: 0px 14px 34px 0px #E7E7E7;
            box-shadow: 0px 14px 34px 0px #E7E7E7;
}

.ServicePlansItems-servicePlanUpperCard-kQp73 {
    padding: 18px;
    border-radius: 10px 10px 16px 16px;
    border: 1px solid var(--primary-border);
    background-color: var(--primary-white-bg);
}

.ServicePlansItems-servicePlanImage-EOMbH {
    width: 32px;
    height: 32px;
    padding: 8px;
    border-radius: 6px;
    background-color: var(--tertiary-gray-bg);
    -ms-flex-negative: 0;
        flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    overflow: hidden;
}

.ServicePlansItems-servicePlanImage-EOMbH>img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
}

.ServicePlansItems-servicePlanCardName-pvN_X {
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    margin: 0;
}

.ServicePlansItems-servicePlanAmount-HN4kW {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
}

.ServicePlansItems-servicePlanDuration-ei0Ao {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: var(--tertiary-foreground);
}

.ServicePlansItems-servicePlanLowerCard-DjDO_ {
    padding: 18px;
}

@media (min-width:1200px) {
    .ServicePlansItems-servicePlanCard-japf8:hover {
        -webkit-box-shadow: 0px 14px 34px 0px #E7E7E7;
                box-shadow: 0px 14px 34px 0px #E7E7E7;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/UserPlan/ServicePlansItems.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,iDAAiC;IAAjC,yCAAiC;IAAjC,iCAAiC;IAAjC,gEAAiC;AACrC;;AAEA;IACI,6CAAqC;YAArC,qCAAqC;AACzC;;AAGA;IACI,aAAa;IACb,kCAAkC;IAClC,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,oBAAc;QAAd,cAAc;IACd,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,6CAAqC;gBAArC,qCAAqC;IACzC;AACJ","sourcesContent":[".servicePlanCard {\n    background-color: var(--secondary-gray-bg);\n    border-radius: 16px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    border: 6px solid var(--primary-white-bg);\n    transition: box-shadow .1s linear;\n}\n\n.servicePlanActiveCard {\n    box-shadow: 0px 14px 34px 0px #E7E7E7;\n}\n\n\n.servicePlanUpperCard {\n    padding: 18px;\n    border-radius: 10px 10px 16px 16px;\n    border: 1px solid var(--primary-border);\n    background-color: var(--primary-white-bg);\n}\n\n.servicePlanImage {\n    width: 32px;\n    height: 32px;\n    padding: 8px;\n    border-radius: 6px;\n    background-color: var(--tertiary-gray-bg);\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.servicePlanImage>img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.servicePlanCardName {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.servicePlanAmount {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 30px;\n}\n\n.servicePlanDuration {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--tertiary-foreground);\n}\n\n.servicePlanLowerCard {\n    padding: 18px;\n}\n\n@media (min-width:1200px) {\n    .servicePlanCard:hover {\n        box-shadow: 0px 14px 34px 0px #E7E7E7;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"servicePlanCard": `ServicePlansItems-servicePlanCard-japf8`,
	"servicePlanActiveCard": `ServicePlansItems-servicePlanActiveCard-XgtSD`,
	"servicePlanUpperCard": `ServicePlansItems-servicePlanUpperCard-kQp73`,
	"servicePlanImage": `ServicePlansItems-servicePlanImage-EOMbH`,
	"servicePlanCardName": `ServicePlansItems-servicePlanCardName-pvN_X`,
	"servicePlanAmount": `ServicePlansItems-servicePlanAmount-HN4kW`,
	"servicePlanDuration": `ServicePlansItems-servicePlanDuration-ei0Ao`,
	"servicePlanLowerCard": `ServicePlansItems-servicePlanLowerCard-DjDO_`
};
module.exports = ___CSS_LOADER_EXPORT___;
